import {call, fork, put, select, take} from 'redux-saga/effects';
import api from 'services';
import * as actionTypes from 'constants/ActionTypes';

export function* getSubscribers(pagination = {}) {
    const store = yield select();
    let response = {};

    try {
        response = yield call(api.getSubscribers, _.merge(store.subscribers, pagination));
    } catch(error) {
        yield put({
            type: actionTypes.GET_SUBSCRIBERS.FAILURE,
        });

        return response.data;
    }

    if (response.status === 200) {

        yield put({
            type: actionTypes.GET_SUBSCRIBERS.SUCCESS,
            data: response.data,
        });

        return response;
    }

    yield put({
        type: actionTypes.GET_SUBSCRIBERS.FAILURE,
        message: response.errors[0].messages[0],
    });

    return response;
}

export function* watchGetSubscribers() {
    while (true) {
        const { data } = yield take(actionTypes.GET_SUBSCRIBERS.REQUEST);
        yield fork(getSubscribers, data);
    }
}


export default [
    watchGetSubscribers,
]


// WEBPACK FOOTER //
// ./app/sagas/users/subscribers.js